/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import { Redirect, Route, Router } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import { history } from 'src/utils/utils';
import AfterSignUpInformation from 'src/views/after-signup';
import CustomerListView from 'src/views/customer/CustomerListView';
import ProductListView from 'src/views/product/ProductListView';
import CreateRfpView from 'src/views/rfp/CreateRfpView';
import EditRfpView from 'src/views/rfp/EditRfpView';
import RfpDashboardView from 'src/views/rfp/RfpDashboardView';
import SubmitRfpView from 'src/views/rfp/SubmitRfpView';
import UpdateRfpView from 'src/views/rfp/UpdateRfpView';


export default function AppLayout() {
  return (
    <div>
      <Router history={history} basename="/admin">
        <DashboardLayout >
          {/* <Route path="/app/home" exact component={DashboardView} /> */}
          <Route path="/app/additional-information" exact component={AfterSignUpInformation} />
          <Route path="/app/create-rfp" exact component={CreateRfpView} />
          <Route path="/app/dashboard-rfp/:rfpId" exact component={RfpDashboardView} />
          <Route path="/app/dashboard/:isFirstLogin?" exact component={ProductListView} />
          <Route path="/app/customers" exact component={CustomerListView} />
          <Route path="/app/update-rfp/:rfpId" exact component={UpdateRfpView} />
          <Route path="/app/edit-rfp/:rfpId" exact component={EditRfpView} />
          <Route path="/app/submit-rfp/:rfpId" exact component={SubmitRfpView} />
          <Route exact path="/app">
            <Redirect from="/app" to="/app/home" exact />
          </Route>
        </DashboardLayout>
      </Router>
    </div>
  );
}
